export default {"src":"/_next/static/media/box_40.51d01ebd.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};